import request from '@/utils/request'
import { getToken } from '@/utils/auth'
import { obj2query } from "@/utils";

export function getTransaction(bankholder_id, start_date, end_date){
  return request({
    url: `/api/statements/${bankholder_id}/${start_date}/${end_date}`,
    method: "get"
  });
}

export function getStatement(bankholder_id, start_date, end_date, query){
  return request({
    url: `/api/v2/statements/${bankholder_id}/${start_date}/${end_date}${obj2query(query)}`,
    method: "get",
  });
}

export function getDetail(uid){
  return request({
    url: `/api/statements/${uid }`,
    method: "get"
  });
}

export function getExcel(bankholder_id, start_date, end_date, filename){
  const baseURL = process.env.VUE_APP_SERVER_BASE_API
  const link = document.createElement('a')
  link.href = `${baseURL}/api/statements/${bankholder_id}/${start_date}/${end_date}/excel?access_token=${getToken()}`
  if(filename){
    link.download = filename
  }
  link.click()
}

export function getPDF(bankholder_id, start_date, end_date, filename){
  const baseURL = process.env.VUE_APP_SERVER_BASE_API
  const link = document.createElement('a')
  link.href = `${baseURL}/api/statements/${bankholder_id}/${start_date}/${end_date}/pdf?access_token=${getToken()}`
  if(filename){
    link.download = filename
  }
  link.click()
}

export function getSenderInfo(uid){
  return request({
    url: `/api/statements/${uid}/senderinfo`,
    method: "get"
  });
}